import PropTypes from 'prop-types';
import React from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';


export default function MenuItemsDropDown(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Tooltip title="Account settings">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    {
                        props.children
                    }
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {
                    props.menuItems.map((item, index) => (
                        item.show && ( <MenuItem
                            onClick={()=>item.onClick()}
                            key={index}>
                            {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                            {item.label}
                        </MenuItem>)
                       

                    ))
                }

            </Menu>
        </React.Fragment>
    );
}


MenuItemsDropDown.defaultProps = {
    menuItems: [
        {
            label: 'Account',
            icon: <Avatar />,
            show: true,
            onClick: () => {
                console.log('Account');
            }
        },
        {
            label: 'Add account',
            icon: <PersonAdd />,
            onClick: () => {
                console.log('Add account');
            }
        },
        {
            label: 'Settings',
            icon: <Settings />,
            onClick: () => {
                console.log('Settings');
            }
        },
    ],

}
MenuItemsDropDown.propTypes = {
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element,
            onClick: PropTypes.func,
        }),
    ),
    children: PropTypes.element.isRequired,
}